import { AssistantJourney } from '../Assistant/journey';
import { AssistantHeader } from './AssistantHeader';

// The legacy package's manifest — a journey like any other. See ./README.md and
// .claude/context/shell-composition.md for header/content, flows/config are inert here (this
// package has no orchestrator) and reuse AssistantJourney's for free.
//
// @type {import('../Assistant/journey').Journey}
export const legacyJourney = {
  id: 'legacy',
  flows: AssistantJourney.flows,
  config: { liveAgent: false, queryLayer: false },
  bareContent: true,
  header: AssistantHeader,
  content: {
    load: () => import('./LegacyAssistantContent'),
    exportName: 'LegacyAssistantContent',
    label: 'Legacy Assistant',
  },
};

export default legacyJourney;
